import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import BarLineChartTemplate from 'Pages/Analytics/SaleAnalytics/Components/BarLineChart.Template'
import { getStore360Charts } from 'Services/Analytics/saleChannel-analytics'

const ChartRow5 = () => {
  const { id } = useParams()
  return (
    <>
      <div className="bg-white p-4 col-span-3 shadow-div_b">
        <div className="mb-4 font-semibold">Net Sales by Hour</div>
        <div className="w-full overflow-y-scroll overflow-x-hidden" style={{ height: 260 }}>
          <BarLineChartTemplate
            chartCode="net_sale_by_hour"
            handleDataFunction={getStore360Charts}
          />
        </div>
      </div>
    </>
  )
}

export default ChartRow5
